import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const wrapper = (sidebarOpen?: boolean) => css`
  ${
    sidebarOpen &&
    css`
    border-bottom: 1px solid ${colors.shadows.getShadow(colors.white, 0.2)};
  `
  };
`;

export const backButton = css`
  color: ${colors.white};
  font-weight: normal;

  &:hover {
    color: ${colors.white};
    font-weight: bold;
  }
`;

export const closeButton = css`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const popper = css`
  position: relative;
  min-width: 200px;
  padding: 5px;
  border-radius: 0px;
  border-width: 0;
  background-color: ${colors.secondary.hover};
`;

export const itemContainer = css`
  cursor: pointer;
  border-bottom: 1px solid ${colors.shadows.getShadow(colors.white, 0.2)};
  padding: 15px 0;
  margin: 0 auto;

  span {
    font-size: 9px;
    display: flex;
    justify-content: center;
    width: 40px;
  }

  &:hover {
    svg {
      color: ${colors.primary.default};
    }
  }
`;
